var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 2.33333H3.66732C3.3137 2.33333 2.97456 2.47381 2.72451 2.72386C2.47446 2.97391 2.33398 3.31304 2.33398 3.66667V11.6667C2.33398 12.0203 2.47446 12.3594 2.72451 12.6095C2.97456 12.8595 3.3137 13 3.66732 13H10.334C10.6876 13 11.0267 12.8595 11.2768 12.6095C11.5268 12.3594 11.6673 12.0203 11.6673 11.6667V3.66667C11.6673 3.31304 11.5268 2.97391 11.2768 2.72386C11.0267 2.47381 10.6876 2.33333 10.334 2.33333H9.00065M5.00065 2.33333C5.00065 1.97971 5.14113 1.64057 5.39118 1.39052C5.64122 1.14048 5.98036 1 6.33398 1H7.66732C8.02094 1 8.36008 1.14048 8.61013 1.39052C8.86018 1.64057 9.00065 1.97971 9.00065 2.33333M5.00065 2.33333C5.00065 2.68696 5.14113 3.02609 5.39118 3.27614C5.64122 3.52619 5.98036 3.66667 6.33398 3.66667H7.66732C8.02094 3.66667 8.36008 3.52619 8.61013 3.27614C8.86018 3.02609 9.00065 2.68696 9.00065 2.33333M5.00065 8.33333H5.00732M5.00065 10.3333H5.00732M7.00065 9.66667L7.66732 10.3333L9.66732 8.33333",
    stroke: "black",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMis);
export default __webpack_public_path__ + "static/media/mis.e04ad42fb564744804bf66dd266c37cc.svg";
export { ForwardRef as ReactComponent };